import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "h-screen flex flex-col items-center justify-center" };
const _hoisted_2 = /*#__PURE__*/ _createTextVNode(" Setting up your shared files vault ");
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-primary font-bold text-xl" }, "Share no longer valid", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "w-full flex flex-col justify-center" }, "The URL you clicked is not / no longer valid.", -1);
export function render(_ctx, _cache) {
    const _component_spinner_modal = _resolveComponent("spinner-modal");
    const _component_card = _resolveComponent("card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.noValidKeysPopup)
            ? (_openBlock(), _createBlock(_component_spinner_modal, { key: 0 }, {
                message: _withCtx(() => [
                    _hoisted_2
                ]),
                _: 1
            }))
            : (_openBlock(), _createBlock(_component_card, {
                key: 1,
                width: "32",
                heigth: "32",
                class: "container flex flex-row flex-wrap"
            }, {
                header: _withCtx(() => [
                    _hoisted_3
                ]),
                default: _withCtx(() => [
                    _hoisted_4
                ]),
                _: 1
            }))
    ]));
}
